import { ErrorActionType } from '../action-types/errorTypes';
import { ErrorActions } from '../actions/errorTypes';
import { Dispatch } from 'redux';
import * as ERV_API from '../../services/ervSalesGate';

export const setErrorInfoText = (text: string) => {
  if (text !== '') {
    ERV_API.logs(text, 'INFO');
  }

  return (dispatch: Dispatch<ErrorActions>) => {
    dispatch({
      type: ErrorActionType.SET_ERROR_INFO_TEXT,
      payload: text,
    });
  };
};

export const setErrorType = (errorType: string) => {
  return (dispatch: Dispatch<ErrorActions>) => {
    dispatch({
      type: ErrorActionType.SET_ERROR_TYPE,
      payload: errorType,
    });
  };
};

export const setValidatePaymentError = (hasError: boolean) => {
  return (dispatch: Dispatch<ErrorActions>) => {
    dispatch({
      type: ErrorActionType.SET_VALIDATE_PAYMENT_ERROR,
      payload: hasError,
    });
  };
};

export const setValidatePaymentErrorMessage = (message: { code: number; message: string }) => {
  return (dispatch: Dispatch<ErrorActions>) => {
    dispatch({
      type: ErrorActionType.SET_VALIDATE_PAYMENT_ERROR_MESSAGE,
      payload: message,
    });
  };
};

export const setTrackingPageName = (trackingPageName: string) => {
  return (dispatch: Dispatch<ErrorActions>) => {
    dispatch({
      type: ErrorActionType.SET_TRACKING_PAGE_NAME,
      payload: trackingPageName,
    });
  };
};

export const setValidation = (validation: ValidationType) => {
  return (dispatch: Dispatch<ErrorActions>) => {
    dispatch({
      type: ErrorActionType.SET_VALIDATION,
      payload: validation,
    });
  };
};
